<template>
  <div>
  <!-- <vue-scroll class="card-base card-shadow--medium mb-30" style="height:400px"> -->
    <div class="p-20 flex">
      <div class="box">
        <h4 class="mv-0 animated fadeInDown">{{title}}</h4>
      </div>
      <div class="box center"></div>
      <div class="box self-flex-end dashboard-actions">
        <el-tooltip :content="$t('common.Refresh')" placement="top">
          <el-button :icon="loadingIcon" size="small" class="dashboard-action-btn" @click="refresh"></el-button>
        </el-tooltip>
        <el-tooltip v-if="id!=null" :content="$t('common.Configure')" placement="top">
          <el-button icon="el-icon-edit-outline" size="small" class="dashboard-action-btn" @click="handleConfigure"></el-button>
        </el-tooltip>
        <el-tooltip v-if="id!=null" :content="$t('common.Delete')" placement="top">
          <el-button icon="el-icon-delete" type="danger" plain size="small" class="dashboard-action-btn" @click="handleDelete"></el-button>
        </el-tooltip>
      </div>
    </div>
    <el-skeleton :count="1" animated :loading="loading">
      <template slot="template">
        <tableSkeleton :rows="parseInt((height-250)/40)" :height="height-250" :columnLabel="[{ label:' ', width:50, sortable: false}, {label: $t('reservation.reservationNumber'), width:100, sortable:false}, {label: $t('reservation.customer'), sortable: true}, { label: $t('reservation.rep'), sortable: true}, {label: $t('reservation.product'), sortable: true}, {label: $t('reservation.reservedAt'), sortable: true}, {label: $t('reservation.qtyReserved'), width: 120, sortable: true}, {label: $t('reservation.qtyAvailable'), width: 120, sortable: true}]"></tableSkeleton>
      </template>
      <template>
        <reservationTable  class="mb-27" :reservations="reservations" :loading="false" :controls="false" :height="height-250" :sort-prop="currentOrderBy" :sort-order="currentSortOrder" @sort-change="handleSortChange"></reservationTable>
      </template>
    </el-skeleton>
    <div class="m-20 flex justify-space-between" style="display:absolute; top:20px;">
        <h4 class="mt-5 mb-0 o-050 fs-14 secondray-text">{{count}} {{ $t('reservation.reservationsFoundOutOf') }} {{totalCount}}</h4>
        <Pagination
          class="mt-5 mb-0 fs-14 secondary-text"
          :current-page="page"
          :total-number-of-page="totalPages"
          @click-previous="clickPrevious"
          @click-next="clickNext" />
    </div>
  <!-- </vue-scroll> -->
</div>
</template>
<script>
import reservationTable from './reservation-table'
 import reservationAPI from '@/services/API/reservation';
import moment from 'moment-timezone'
import tableSkeleton from '@/components/skeleton/table-skeleton'
import Pagination from '@/components/pagination.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'reservation-order-dashboard-card',
	props: {
    uuid: {
      type: String
    },
    id : {
      type : Number
    },
    dashboard: {
      type: Object,
      default: null
    },
    position : {
      type : Number,
      required: true,
    },
    filters : {
      type : Boolean,
      default : true
    },
    orderBy : {
      type : Object
    },
    filters : {
      type : Object
    },
    title : {
      type : String,
      default : null,
    },
    salesReps : {
      type : Array
    },
    height: {
      type: Number
    }
	},
  data() {
    return {
      user : null,
      loading : false,
      reservations : [],
      timer : '',
      totalCount : null,
      page : 1,
      totalPages : null,
      currentOrderBy: 'date',
      currentDirection: 'DESC',
    };
  },components: {
    reservationTable,
    tableSkeleton,
    Pagination
  },
	methods: {
    handleConfigure () {
      this.$emit('configure', this.dashboard);
    },
    handleDelete(){
      this.deleteDashboard(this.id)
        .then(()=>{
          this.$message({
          message: 'Le canal a été supprimé avec succès.',
          type: 'success'
        });
        })
    },
    refresh () {
      this.cancelAutoUpdate();
      this.fetchReservations()
        .then(() => this.createTimer())
    },
    clickPrevious () {
      if (this.page > 1) {
          this.page -= 1;
      }
      this.refresh();
    },
    clickNext () {
      if (this.page < this.totalPages) {
        this.page += 1;
        this.refresh();
      }
    },
    handleSortChange ({ prop, order }) {
      if (prop == null) return;

      let direction = 'ASC';
      if (order === 'descending') direction = 'DESC';
      if (order === null) {
        this.currentOrderBy = 'date';
        this.currentDirection = 'DESC';
      } else {
        this.currentOrderBy = prop;
        this.currentDirection = direction;
      }

      this.page = 1;
      this.refresh();
    },
    fetchReservations(){
      this.loading=true;
      let params = {};

      params.types = [];
      if (this.filters.productAvailable) params.types.push('active');
      if (this.filters.productToCome) params.types.push('delayed');
      if (this.filters.intent) params.types.push('intent');
      if (this.filters.completed) params.types.push('completed');

      params.redFlag = this.filters.redFlag?this.filters.redFlag:undefined;
      params.yellowFlag = this.filters.yellowFlag?this.filters.yellowFlag:undefined;
      params.greenFlag = this.filters.greenFlag?this.filters.greenFlag:undefined;
      params.salesRep = this.salesReps?this.salesReps:undefined;
      params.delayed = this.filters.delayed?this.filters.delayed:undefined;
      params.page = this.page;
      params.limit = 50;
      params.orderBy = this.currentOrderBy;
      params.direction = this.currentDirection;

      // console.log("params : ", params);

      return reservationAPI.fetchReservations(params).then(reservations => {
        this.reservations = reservations.list;
        this.totalCount = reservations.count;
        this.totalPages = reservations.pages;
        this.updateTotalElement({ uuid: this.uuid, totalElement: this.totalCount});
        this.loading=false;
      });
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

    },
    setSalesRepId(userId){
       this.fetchReservations();
    },
    createTimer () {
      this.timer = setInterval(this.fetchReservations, 60000 + (this.position * 2000));
    },
    cancelAutoUpdate () { clearInterval(this.timer) },
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('genericDashboards', ['updateTotalElement','deleteDashboard']),
	},
	computed: {
    currentSortOrder() {
      return this.currentDirection === 'ASC' ? 'ascending' : 'descending';
    },
    loadingIcon(){
      if(this.loading)return 'el-icon-loading'
      else return 'el-icon-refresh'
    },
    count(){
      if(this.reservations==null)return 0;
      else return this.reservations.length;

    },
    ...mapGetters('users', [ 'filterUserWithRoleRep']),
	},
  created(){
    this.user = JSON.parse(localStorage.user);
    if (this.orderBy != null) {
      this.currentOrderBy = _.get(this.orderBy, 'orderName', this.currentOrderBy);
      this.currentDirection = _.get(this.orderBy, 'direction', this.currentDirection);
    }
    this.fetchReservations()
      .then(() => this.createTimer())
    this.fetchAdminUsers();

  },
  beforeDestroy () {
    this.cancelAutoUpdate();
  }
}
</script>
<style lang="scss" scoped>

.dashboard-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dashboard-action-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 8px;
}




</style>
